import { j as s } from "../../../../jsx-runtime-B6kdoens.js";
import { forwardRef as t } from "react";
import { I as a } from "../../../../IconBase-CxZyIWw2.js";
const i = t((r, e) => /* @__PURE__ */ s.jsx(
  a,
  {
    ref: e,
    ...r,
    image: (o) => /* @__PURE__ */ s.jsxs(
      "svg",
      {
        xmlns: "http://www.w3.org/2000/svg",
        width: 16,
        height: 16,
        fill: "none",
        viewBox: "0 0 16 16",
        ...o,
        children: [
          /* @__PURE__ */ s.jsx(
            "mask",
            {
              id: "mask0_2974_3496",
              width: 17,
              height: 12,
              x: 0,
              y: 2,
              maskUnits: "userSpaceOnUse",
              style: {
                maskType: "alpha"
              },
              children: /* @__PURE__ */ s.jsx(
                "path",
                {
                  fill: "currentColor",
                  d: "M.76 8.71h11.5c-1.25.93-2.44 2.36-2.44 4.46 0 .41.34.75.75.75s.75-.34.75-.75c0-3.19 4.11-4.45 4.15-4.46a.73.73 0 0 0 .54-.73.75.75 0 0 0-.57-.71c-.17-.04-4.07-1.07-4.07-4.52 0-.41-.34-.75-.75-.75s-.75.34-.75.75c0 2.02 1.01 3.48 2.22 4.46H.75c-.41 0-.75.34-.75.75s.35.75.76.75"
                }
              )
            }
          ),
          /* @__PURE__ */ s.jsx("g", { mask: "url(#mask0_2974_3496)", children: /* @__PURE__ */ s.jsx("path", { fill: "currentColor", d: "M0 0h16v16H0z" }) })
        ]
      }
    )
  }
));
i.displayName = "AgencyArrowRightIcon";
export {
  i as AgencyArrowRightIcon,
  i as default
};
//# sourceMappingURL=index.js.map
